import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'

import { type InputValues } from '../utils'

export type ToggleShowArrowButtonProps = {
  index: number
}

export const ToggleShowArrowButton = ({
  index,
}: ToggleShowArrowButtonProps) => {
  const name = React.useMemo(
    () => `strategies.${index}.showArrow` as const,
    [index],
  )
  const { getValues, setValue, watch } = useFormContext<InputValues>()
  const showArrow = watch(name)
  const { t } = useTranslation()

  const handleClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    const showArrow = getValues(name)
    setValue(name, !showArrow)
  }, [getValues, name, setValue])

  return (
    <StyledButton fillMode="flat" onClick={handleClick}>
      {showArrow ? t('hide_selection') : t('show_selection')}
    </StyledButton>
  )
}
